jQuery(document).ready(function($) {
  if($("body.user-logged-in")[0]) {
    const mainContent = $("main");
    const dashboardMenu = $("#dashboard-menu");
    const headerMenu = $("header");
    const toggleButton = headerMenu.find(".action-wrapper .btn-expand-collapse");
    const svgIcon = toggleButton.find("svg use");

    const CLASS_EXPANDED = "expanded";
    const CLASS_EXPAND = "expand";
    const STORAGE_KEY = "dashboard-menu-expanded"; // values: "expanded" | "expand"

    function getStoredState() {
      const value = localStorage.getItem(STORAGE_KEY);
      return value === CLASS_EXPANDED || value === CLASS_EXPAND ? value : null;
    }

    function applyState(state, options) {
      const persist = options && options.persist === false ? false : true;

      // Ensure only one of the two classes is present
      [mainContent, dashboardMenu, headerMenu].forEach(($el) => {
        $el.removeClass(CLASS_EXPANDED).removeClass(CLASS_EXPAND).addClass(state);
      });

      if (persist) {
        console.log(state);
        localStorage.setItem(STORAGE_KEY, state);
      }
    }

    function resolveDesiredState() {
      // On small windows, default to "expand" on initial load, but do not force
      if ($(window).width() < 400) {
        return {state: CLASS_EXPAND, forced: false};
      }

      const stored = getStoredState();
      // Default to "expand" if nothing stored
      return {state: stored || CLASS_EXPAND, forced: false};
    }

    function toggleState() {
      const current = headerMenu.hasClass(CLASS_EXPANDED) ? CLASS_EXPANDED : CLASS_EXPAND;
      const next = current === CLASS_EXPANDED ? CLASS_EXPAND : CLASS_EXPANDED;
      applyState(next, {persist: true});
    }

    // Initial apply based on storage and window size
    const initial = resolveDesiredState();
    applyState(initial.state, {persist: true});

    // Toggle on click (allowed on all window sizes)
    toggleButton.on("click", function () {
      toggleState();
    });
  }

  // Do not force state on resize; user preference should prevail
});
